export default __webpack_public_path__ + "static/media/armbands_of_ferine_anger.0e7deb5d.jpg";